<template>
  <v-container class="mt-12">
    <v-row class="text-center mt-9">
      <v-col>
        <h1 class="my-name">
          Alejandro Fernandes Antunes
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="caption-text text-center">
          Professional Transmogrifier, Wholehearted Musician
        </p>
        <div class="text-center">
          <v-btn
            class="ma-2"
            dark
            medium
            tile
            color="grey darken-4"
            @click="linkedIn()"
          >
            <v-icon dark>mdi-linkedin</v-icon>
          </v-btn>
          <v-btn
            class="mx-2"
            dark
            medium
            tile
            color="grey darken-4"
            @click="bandCamp()"
          >
            <v-icon dark>mdi-bandcamp</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "MainPage",
  methods: {
    linkedIn() {
      window.open(
        "https://www.linkedin.com/in/alejandro-fernandes-antunes-uy",
        "_blank"
      );
    },
    bandCamp() {
      window.open("https://alefernandesantunes.bandcamp.com/", "_blank");
    }
  }
};
</script>
<style lang="scss">
.my-name {
  font-family: "Source Code Pro", monospace;
  text-transform: uppercase;
  font-weight: 300;
  font-size: 4rem;
}
.caption-text {
  font-family: "Source Code Pro", monospace;
  text-transform: uppercase;
  font-weight: 200;
  font-size: 1rem;
  margin-top: 5vh;
}
</style>
